import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useEndUser } from "@/lib/endUserAuth";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Activity, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AppClaimPage() {
  const { claim } = useEndUser();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const [email, setEmail] = useState(params.get("email") || "");
  const [code, setCode] = useState(params.get("code") || "");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres");
      return;
    }
    setSubmitting(true);
    try {
      await claim({ email: email.trim(), code: code.trim(), name: name.trim(), password });
      toast.success("¡Cuenta activada!");
      navigate("/app", { replace: true });
    } catch (err) {
      const msg = err.response?.data?.error || "No pudimos activar la cuenta";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-12 h-12 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center mb-3">
            <Activity className="w-6 h-6" />
          </div>
          <h1 className="text-xl font-bold text-foreground">Activa tu cuenta</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Crea tu contraseña para acceder a tus planes
          </p>
        </div>

        <Card className="shadow-md">
          <CardContent className="p-6">
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-xs">Correo</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@correo.com"
                  required
                />
              </div>
              <div>
                <Label htmlFor="code" className="text-xs">Código de invitación</Label>
                <Input
                  id="code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="6 dígitos"
                  required
                />
              </div>
              <div>
                <Label htmlFor="name" className="text-xs">Tu nombre</Label>
                <Input
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="¿Cómo te llamas?"
                />
              </div>
              <div>
                <Label htmlFor="password" className="text-xs">Crea una contraseña</Label>
                <Input
                  id="password"
                  type="password"
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Mínimo 6 caracteres"
                  required
                />
              </div>
              <Button type="submit" className="w-full rounded-full" disabled={submitting}>
                {submitting && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />}
                Activar cuenta
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-muted-foreground mt-4">
          ¿Ya tienes cuenta?{" "}
          <Link to="/app/login" className="text-primary font-medium">Inicia sesión</Link>
        </p>
      </div>
    </div>
  );
}
